<template>

    <modal :show="showModal" @closeModal="close">

        <div class="mep">

            <img src="/img/providers/illustration-technical-error.svg" class="mep__img">

            <h2 class="mep__title">{{ $t('unsupported_provider_title') }}</h2>

            <p class="mep__link">{{ email }}</p>

            <p class="mep__text">{{ computedModalText }}</p>

            <button class="mep__btn" @click="close">{{ $t('unsupported_provider_cta') }}</button>

        </div>

    </modal>

</template>

<script>

import Tag from '@/modules/tag'

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-error-provider',

    components: {Modal},

    props: {
        email: {
            type: String,
            default: ''
        }
    },

    computed: {
        computedModalText() {
            return this.shutdown
                ? this.$tc('login_provider_impossible_to_connect', 0, {provider: this.provider})
                : this.$t('unsupported_provider_text')
        }
    },

    data() {
        return {
            showModal: false,
            provider: '',
            shutdown: false
        }
    },

    methods: {

        show(error) {
            Tag.popupAmplitude(this, 'unknown_provider')
            this.provider = error && error.data && error.data.provider
            this.shutdown = error && error.data && error.data.reason === 'shutdown'
            this.showModal = true
        },

        close() {
            this.showModal = false
        }
    }
}

</script>

<style lang="scss" scoped>

.mep {
    padding: 32px 20px;
    text-align: start;
    max-width: 400px;
    @media screen and (min-width: $above-tablet-length) {
        text-align: center;
    }

    &__img {
        width: 72px;
        object-fit: contain;

        @media screen and (min-width: $above-tablet-length) {
            width: 96px;
        }
    }

    &__title {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 600;
        line-height: 1.17;
    }

    &__link {
        margin-top: 20px;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.18;
        color: $aquamarine;
    }

    &__text {
        margin-top: 20px;
        font-size: 17px;
        line-height: 1.29;
    }

    &__btn {
        cursor: pointer;
        margin-top: 20px;
        padding: 24px;
        width: 100%;
        border-radius: 32px;
        background-color: $timberwolf;

        font-size: 16px;
        font-weight: 600;
        line-height: 1;
    }

}

</style>
